<div class="ebands">

  <header class="ebands__head">
    <div>
      <h1 class="ebands__title">
        <i class="fa-solid fa-layer-group"></i>
        {{ 'EVAL_BANDS.TITLE' | translate }}
      </h1>
      <p class="ebands__sub">{{ 'EVAL_BANDS.SUBTITLE' | translate }}</p>
    </div>

    @if (canWrite) {
      <button type="button" class="ebands__save"
              [disabled]="!canSave()" (click)="save()">
        @if (saving()) { <span class="ebands__spinner"></span> }
        <i class="fa-solid fa-floppy-disk"></i>
        {{ 'COMMON.SAVE' | translate }}
      </button>
    }
  </header>

  @if (!canWrite) { <app-read-only-notice></app-read-only-notice> }

  @if (errored()) {
    <app-error-state titleKey="EVAL_BANDS.ERROR_TITLE"
                     messageKey="EVAL_BANDS.ERROR_DESC"
                     (retry)="load()"></app-error-state>
  } @else if (loading()) {
    <p class="ebands__dim">{{ 'LOADINGS.LOADING' | translate }}</p>
  } @else {

    <!-- Les défauts de continuité se voient pendant la saisie : aller au bout
         du formulaire pour se le faire refuser serait une perte de temps. -->
    @if (issues().length) {
      <div class="ebands__issues" role="alert">
        <p class="ebands__issues-title">
          <i class="fa-solid fa-triangle-exclamation"></i>
          {{ 'EVAL_BANDS.ISSUES_TITLE' | translate }}
        </p>
        <ul>
          @for (issue of issues(); track issue) { <li>{{ issue }}</li> }
        </ul>
      </div>
    }

    <!-- Règle en tête : la couverture 0–100 se lit d'un coup d'œil, ce qu'un
         tableau de nombres ne donne pas. -->
    <div class="ebands__ruler" aria-hidden="true">
      @for (b of bands(); track b.id) {
        <span class="ebands__ruler-seg"
              [style.background]="b.color || '#94a3b8'"
              [style.flex-grow]="(b.maxPercentage - b.minPercentage) + 1">
          {{ b.minPercentage }}–{{ b.maxPercentage }}
        </span>
      }
    </div>

    <div class="ebands__list">
      @for (b of bands(); track b.id) {
        <article class="ebands__card" [style.border-inline-start-color]="b.color || '#94a3b8'">

          <header class="ebands__card-head">
            <span class="ebands__code">{{ b.code }}</span>
            <label class="ebands__color">
              <span class="ebands__label">{{ 'EVAL_BANDS.COLOR' | translate }}</span>
              <input type="color" [value]="b.color || '#94a3b8'"
                     (input)="patch(b.id, { color: $any($event.target).value })" [disabled]="!canWrite">
            </label>
          </header>

          <div class="ebands__row">
            <label class="ebands__field">
              <span class="ebands__label">{{ 'EVAL_BANDS.MIN' | translate }}</span>
              <input type="number" min="0" max="100" [value]="b.minPercentage"
                     (input)="onNumber(b.id, 'minPercentage', $any($event.target).value)" [disabled]="!canWrite">
            </label>
            <label class="ebands__field">
              <span class="ebands__label">{{ 'EVAL_BANDS.MAX' | translate }}</span>
              <input type="number" min="0" max="100" [value]="b.maxPercentage"
                     (input)="onNumber(b.id, 'maxPercentage', $any($event.target).value)" [disabled]="!canWrite">
            </label>
          </div>

          <!-- Trois langues côte à côte : le produit est trilingue, et remplir
               une seule colonne laisserait un libellé vide en production. -->
          <div class="ebands__group">
            <span class="ebands__group-title">{{ 'EVAL_BANDS.LABEL' | translate }}</span>
            <div class="ebands__row ebands__row--three">
              <label class="ebands__field">
                <span class="ebands__label">FR</span>
                <input type="text" [value]="b.labelFr"
                       (input)="patch(b.id, { labelFr: $any($event.target).value })" [disabled]="!canWrite">
              </label>
              <label class="ebands__field">
                <span class="ebands__label">AR</span>
                <input type="text" dir="rtl" [value]="b.labelAr"
                       (input)="patch(b.id, { labelAr: $any($event.target).value })" [disabled]="!canWrite">
              </label>
              <label class="ebands__field">
                <span class="ebands__label">EN</span>
                <input type="text" [value]="b.labelEn"
                       (input)="patch(b.id, { labelEn: $any($event.target).value })" [disabled]="!canWrite">
              </label>
            </div>
          </div>

          <div class="ebands__group">
            <span class="ebands__group-title">{{ 'EVAL_BANDS.PLAN' | translate }}</span>
            <div class="ebands__row ebands__row--three">
              <label class="ebands__field">
                <span class="ebands__label">FR</span>
                <input type="text" [value]="b.planLabelFr"
                       (input)="patch(b.id, { planLabelFr: $any($event.target).value })" [disabled]="!canWrite">
              </label>
              <label class="ebands__field">
                <span class="ebands__label">AR</span>
                <input type="text" dir="rtl" [value]="b.planLabelAr"
                       (input)="patch(b.id, { planLabelAr: $any($event.target).value })" [disabled]="!canWrite">
              </label>
              <label class="ebands__field">
                <span class="ebands__label">EN</span>
                <input type="text" [value]="b.planLabelEn"
                       (input)="patch(b.id, { planLabelEn: $any($event.target).value })" [disabled]="!canWrite">
              </label>
            </div>
          </div>
        </article>
      }
    </div>
  }
</div>
